module.exports = __webpack_public_path__ + "img/BEFIRST_01.5c5b25f2.jpg";